import { useEffect, useMemo, useState } from "react";

import {
    getOrders,
} from "../services/adminApi";

import OrderHeader from "../components/orders/OrderHeader";
import OrderStats from "../components/orders/OrderStats";
import OrderFilterBar from "../components/orders/OrderFilterBar";
import OrderTable from "../components/orders/OrderTable";

import "../css/Order.css";

function Orders() {

    const [orders, setOrders] = useState([]);

    const [loading, setLoading] = useState(true);

    const [filters, setFilters] = useState({

        search: "",

        status: "",

        payment: "",

        provider: "",

    });

    const loadOrders = async () => {

        try {

            setLoading(true);

            const res = await getOrders();

            setOrders(res.data.orders || []);

        } catch (error) {

            console.error("Failed to load orders:", error);

        } finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        loadOrders();

    }, []);

    const filteredOrders = useMemo(() => {

        return orders.filter((order) => {

            const search = filters.search.toLowerCase();

            const matchesSearch =

                !search ||

                order.orderNumber?.toLowerCase().includes(search) ||

                order.customerSnapshot?.name
                    ?.toLowerCase()
                    .includes(search) ||

                order.providerSnapshot?.businessName
                    ?.toLowerCase()
                    .includes(search);

            const matchesStatus =

                !filters.status ||

                order.status === filters.status;

            const matchesPayment =

                !filters.payment ||

                order.payment?.status === filters.payment;

            const matchesProvider =

                !filters.provider ||

                order.providerSnapshot?.businessName ===
                filters.provider;

            return (

                matchesSearch &&

                matchesStatus &&

                matchesPayment &&

                matchesProvider

            );

        });

    }, [orders, filters]);

    const stats = {

        total: orders.length,

        pending: orders.filter(
            order => order.status === "Pending"
        ).length,

        preparing: orders.filter(
            order => order.status === "Preparing"
        ).length,

        ready: orders.filter(
            order => order.status === "Ready"
        ).length,

        outForDelivery: orders.filter(
    order => order.status === "Out For Delivery"
).length,

        delivered: orders.filter(
            order => order.status === "Delivered"
        ).length,

        cancelled: orders.filter(
            order => order.status === "Cancelled"
        ).length,

        revenue: orders
            .filter(order => order.status === "Delivered")
            .reduce(
                (sum, order) => sum + (order.grandTotal || 0),
                0
            ),

    };

    return (

        <div className="order-page">

            <OrderHeader
                totalOrders={stats.total}
                onRefresh={loadOrders}
            />

            <OrderStats
                stats={stats}
            />

            <OrderFilterBar
                orders={orders}
                filters={filters}
                setFilters={setFilters}
            />

            <OrderTable
                orders={filteredOrders}
                loading={loading}
            />

        </div>

    );

}

export default Orders;